import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import ClassScheduleService from '../../services/classScheduleServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('classschedule/list', async (query, thunkAPI) => {
  try {
    const response = await ClassScheduleService.getList(query);

    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getArchiveList = createAsyncThunk('classschedule/archiveList', async (query, thunkAPI) => {
  try {
    const response = await ClassScheduleService.getArchiveList(query);

    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('classschedule/create', async (data, thunkAPI) => {
  try {
    const response = await ClassScheduleService.create(data);
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getDetail = createAsyncThunk('classschedule/detail', async (id, thunkAPI) => {
  try {
    const response = await ClassScheduleService.getDetail(id);

    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('classschedule/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ClassScheduleService.update(id, data);
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const duplicateSchedule = createAsyncThunk('classschedule/duplicateSchedule', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ClassScheduleService.duplicateSchedule(id, data);
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('classschedule/changeStatus', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ClassScheduleService.changeStatus(id, data);
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('classschedule/delete', async (id, thunkAPI) => {
  try {
    const response = await ClassScheduleService.del(id);
    thunkAPI.dispatch(setMessage({ message: 'Berhasil menghapus data permanen', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error?.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  list: [],
  archiveList: [],
  isLoading: false,
  data: [],
  error: []
};

const classSchedule = createSlice({
  name: 'classschedule',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.list = action.payload;
      state.error = [];
    });
    builder.addCase(getList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.errors;
    });

    builder.addCase(getArchiveList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getArchiveList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.archiveList = action.payload;
      state.error = [];
    });
    builder.addCase(getArchiveList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.errors;
    });

    builder.addCase(getDetail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = [];
    });
    builder.addCase(getDetail.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = [];
    });
    builder.addCase(createData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.errors;
    });

    builder.addCase(updateData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = [];
    });
    builder.addCase(updateData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.errors;
    });

    builder.addCase(duplicateSchedule.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(duplicateSchedule.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = [];
    });
    builder.addCase(duplicateSchedule.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.errors;
    });

    builder.addCase(changeStatus.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(deleteData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteData.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(deleteData.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

const { reducer } = classSchedule;
export default reducer;
